
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BaseModal',
  emits: ['closeModal']
})
